import Pocketbase from 'pocketbase';
import { PB_HOST_URL } from '../utils/Config';
export const PBClient = new Pocketbase(PB_HOST_URL);